(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("CNUI"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "CNUI", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["cn-domain-print"] = factory(require("react"), require("CNUI"), require("lodash"));
	else
		root["cn-domain-print"] = factory(root["React"], root["CNUI"], root["_"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__77__) {
return 